<app-notification-settings></app-notification-settings>
<div class="notification-settings-page">
    <div class="notification-settings-page-title">
        Hello {{userName}}, and welcome to Synergy!
    </div>
    <div class="notification-settings-page-body" (click)="notificationSettings()" (keypress)="notificationSettings()">
        Please click here update your global notification settings here
    </div>
</div>